import * as Programs from "../../programs";
import processMap from "../../util/processMap";

const id = "tutorial";
const map = `
----------.......
----------.......
--@---A---.......
------a---.......
---@--a---.......
----------.......
----------.......
`;
const enemies = [Programs.Sentinel];
const level = processMap(id, map, enemies);

export default level;

// 1#1:20
